import { Component } from '@angular/core';
import { Angulartics2Facebook } from 'angulartics2/facebook';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Location, LocationStrategy } from '@angular/common';
import { ScriptService } from './core/services/script.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent {
  showFooter: Boolean = true;
  showHeader: Boolean = true;
  title = 'app';
  constructor(angulartics2Facebook: Angulartics2Facebook, private titleService: Title,
    private router: Router, private location: Location, private script: ScriptService, private locationStrategy: LocationStrategy) {
    angulartics2Facebook.startTracking();
    if (!this.location.path().includes('')) {
      // load script for tawk widget
      this.script.load('tawk').catch(error => console.log(error));
    }
    this.router.events.subscribe(val => {
      const path = this.locationStrategy.path();
      if (path.includes('property') && this.isMobile()) {
        this.showHeader = false;
      } else {
        this.showHeader = true;
      }
      if (path === '/') {
        this.showFooter = false;
      } else {
        this.showFooter = true;
      }
    });
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }
  onActivate(event) {
    const path = this.locationStrategy.path();
    if (path.includes('results')) {
      return;
    }
    window.scroll(0, 0);
  }

  isMobile() {

    const w = window.innerWidth;
    if (w < 992) {
      return true;
    }

    return false;
  }

}
